import { Controller } from "@hotwired/stimulus"

export function track(event, payload) {
  if (window.umami) {
    window.umami.track(event, payload)
    return
  }

  document.querySelector("script[data-website-id]")?.addEventListener("load", () => window.umami?.track(event, payload), { once: true })
}

export default class extends Controller {
  static values = { event: String, payload: Object, auto: Boolean }

  connect() {
    if (this.autoValue && !document.documentElement.hasAttribute("data-turbolinks-preview")) this.track()
  }

  track() {
    track(this.eventValue, this.payloadValue)
  }
}
